import { Injectable } from '@angular/core';

import { Observable, Observer, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSecurityService } from '../common/user-security.service';
import { LocalStorageService } from './local-storage.service';
import { MasterConstants } from '../../common/constants/master-constants';
import { DashboardService } from '../seed/dashboard.service';
import { LolLoggerService } from '../../common/shared/lol-logger.service';

@Injectable()
export class AppResolver  {
  validateEvolveData: any;
  isEvolveAccess = false;
  isCompanyCode = false;
  isCropYear = false;
  ccList: any;

  constructor(private userSecurityService: UserSecurityService,
    private localStorageService: LocalStorageService,
    private dashboard: DashboardService) {
  }

  resolve(): Observable<boolean> {
    if (this.localStorageService.get('token')) {
      this.isEvolveAccess = false;
      this.isCompanyCode = false;
      this.isCropYear = false;

      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)
        && this.localStorageService.get(MasterConstants.EVOLVE_ACCESS) != 'null'
        && this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)
        && this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
        return Observable.create((observer: Observer<boolean>) => {
          observer.next(true);
          observer.complete();
        });
      }

      return Observable.create((observer: Observer<boolean>) => {
        forkJoin(
          this.userSecurityService.validateEvolve().pipe(map((response: Response) => response)),
          this.dashboard.getCompanyCode().pipe(map((response: Response) => response)),
          this.dashboard.getCropYear().pipe(map((response: Response) => response))
        ).subscribe(
          data => {
            const evolveAccessData = data[0];
            const companyCodeData: any = data[1];
            const cropYearData: any = data[2];
            if (evolveAccessData) {
              this.validateEvolveData = evolveAccessData;
              this.localStorageService.set(MasterConstants.EVOLVE_ACCESS, JSON.stringify(this.validateEvolveData));
              if (this.validateEvolveData && this.validateEvolveData != null && this.validateEvolveData.resultData != null && this.validateEvolveData.resultData.length > 0) {
                this.isEvolveAccess = true;
              }
            }

            if (companyCodeData) {
              let isCCSet = false, isSelectedCom;
              if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
                isSelectedCom = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
              }
              else {
                isSelectedCom = MasterConstants.US_COMPANYCODE;
              }

              for (const com in companyCodeData) {
                if (companyCodeData[com].companyCode == isSelectedCom) {
                  this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(companyCodeData[com].companyCode));
                  isCCSet = true;
                }

                if (companyCodeData[com].companyCode) {
                  this.isCompanyCode = true;
                }
              }
              this.ccList = companyCodeData;
              if (!isCCSet && this.ccList.length > 0) {
                this.localStorageService.set(MasterConstants.HEADER_COMPANY_CODE, JSON.stringify(companyCodeData[0].companyCode));
                isCCSet = true;
              }
            }

            if (cropYearData) {
              for (const year in cropYearData) {
                if (cropYearData[year].active == true) {
                  this.localStorageService.set(MasterConstants.ACTIVE_CROP_YEAR, JSON.stringify(cropYearData[year]));
                  this.localStorageService.set(MasterConstants.HEADER_CROP_YEAR, JSON.stringify(cropYearData[year].cropYear));
                  if (cropYearData[year].cropYear) {
                    this.isCropYear = true;
                  }
                }
              }
            }

            if (this.isEvolveAccess
              && this.isCompanyCode
              && this.isCropYear) {
              observer.next(true);
              observer.complete();
            }
            else {
              observer.next(false);
              observer.complete();
            }
          },
          err => LolLoggerService.error(err)
        );
      });
    }
  }
}
